// extracted by mini-css-extract-plugin
export default {"whyChooseWrapper":"WhyChoose_whyChooseWrapper__rgQH7","whyChoose":"WhyChoose_whyChoose__89Etx","whyReason":"WhyChoose_whyReason__43+jN","whyText":"WhyChoose_whyText__FpLoI"};